import { useId, useRef } from "react";
import useDialog from "../hooks/useDialog";
import ui from "./ui.module.css";

const ConfirmSheet = ({
  title,
  children,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) => {
  const titleId = useId();
  const confirmRef = useRef(null);
  useDialog(onCancel, confirmRef);

  return (
    <div className={ui.sheetBackdrop} onClick={onCancel}>
      <div
        className={ui.sheet}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id={titleId}>{title}</h2>
        {children}
        <div className={ui.sheetActions}>
          <button
            ref={confirmRef}
            type="button"
            className={`${ui.button} ${ui.primary}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
          <button
            type="button"
            className={`${ui.button} ${ui.cancel}`}
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSheet;
